import React from "react"
import {
  StyledClickToDownloadMedium,
  StyledDownloadAnchor,
} from "../Typography"
import report from "../../downloads/abcworld-impact-report-2020.pdf"
import styled from "styled-components"

const StyledClickHereToDownloadDesktopWrapper = styled.div`
  background-color: #0f6495;
  padding-top: 2em;
  padding-bottom: 2em;
  padding-left: 2em;
  padding-right: 30px;

  margin-bottom: 30px;
`

const Desktop = () => {
  return (
    <StyledClickHereToDownloadDesktopWrapper>
      <StyledClickToDownloadMedium>
        Click{" "}
        <StyledDownloadAnchor
          href={report}
          download="ABC World Impact Report 2020"
        >
          <u>here</u>
        </StyledDownloadAnchor>{" "}
        to download the full report
      </StyledClickToDownloadMedium>
    </StyledClickHereToDownloadDesktopWrapper>
  )
}

export default Desktop
